export default {
  TitlePopupEsign: {
    ConfirmEsign: 'Xác nhận ký số',
    TimesUp: 'Hết thời hạn xác nhận ký số',
    TimeRemain: 'Thời gian còn lại',
    AcceptedRequest: 'Yêu cầu ký số đã được xác nhận',
    RejectedRequest: 'Yêu cầu ký số đã bị từ chối',
    ExpiredCert: 'Chứng thư số hết hiệu lực',
    InvalidCert: 'Chứng thư số không hợp lệ',
    CertNotSigned: 'Khách hàng chưa ký giấy xác nhận',
    UnknownCert: 'Trạng thái chứng thư số bị thu hồi hoặc không rõ',
  },

  Message: {
    SuggestInstallEsign_1: 'Bạn chưa có ứng dụng MISA eSign?',
    SuggestInstallEsign_2: 'Quét mã QR code để tải và cài đặt',

    NotiSendRequest_11: 'Yêu cầu xác nhận ký đã được gửi về thiết bị ',
    NotiSendRequest_12: ' của bạn',

    NotiSendRequest_21: 'Vui lòng mở ứng dụng MISA eSign và bấm ',
    NotiSendRequest_22: 'Đồng ý',
    NotiSendRequest_23: ' để xác nhận ký tờ khai',

    EsignSuccess: 'MISA eSign: Yêu cầu ký số đã được chấp nhận',
    EsignFail_1: 'MISA eSign: Yêu cầu ký số đã bị từ chối',
    EsignFail_2: 'MISA eSign: Yêu cầu ký số đã hết hạn',
  },

  ContentPopupEsign: {
    CloseAfter3s: 'Cửa sổ sẽ tự động đóng sau 3s.',
    CloseNow: 'Đóng ngay',
    Application: 'Ứng dụng',
    RequestCode: 'Mã yêu cầu',
    DocType: 'Loại tài liệu',
    Account: 'Tài khoản',
    CertName: 'Tên chứng thư',
  },

  CertTitle: 'Chọn chứng thư số',
  CertContent: {
    Email: 'Tài khoản',
    CertStatusNumber: 'Số chứng thư số',
    EffectiveTime: 'Hiệu lực',
    USBToken: 'Ký số trực tiếp qua USB TOKEN',
    USBTokenRequire_1: '1. Máy tính đang dùng cần cài đặt công cụ MISA KYSO.',
    USBTokenRequire_2: '2. Bạn cần cắm USB chứa chứng thư số khi thực hiện ký số',
  },
};
